import validator from "validator";

export const getNavigateUrl = ({customer, customerFull, customerId, category: paramCategory, id: messageId}, category) => {
	// console.log("getNavigateUrl: ");
	// console.log("customer: ", customer);
	// console.log("customerFull: ", customerFull);
	// console.log("customerId: ", customerId);
	// console.log("paramCategory: ", paramCategory);
	// console.log("messageId: ", messageId);
	// console.log("category: ", category);
	let url = "";
	const categoryL = category ?? paramCategory;
	//if customer is null or not an object, but a string, then it's probably that customerFull is there and we use that instead
	const isCustomerString = typeof customer === "string";
	if (customerFull && typeof customerFull === "object") {
		// console.log("customerFull: ");
		if (customerFull?.__typename === "organizationUser") {
			url = "/contact/" + customerFull.id;
		}
		else if (customerFull?.__typename === "domainUser") {
			url = "/newcontact/s/" + customerFull.id;
		}
	}
	else if (customer?.__typename === "domainUser" || (isCustomerString && validator.isMobilePhone(customer))) { //customer not registered as organizationUser
		if (categoryL.startsWith("phone_register")) {
			url = "/newcontact/s/" + customerId;
		}
		else if (categoryL.startsWith("email_register")) {
			url = "/newcontact/s/" + customerId;
		}
	}
	else if (customer?.__typename === "organizationUser") { //customer registered as organizationUser
		if (categoryL.startsWith("phone_cc")) {
			url = "/contact/" + customerId;
		}
		else if (categoryL.startsWith("email_cc")) {
			url = "/contact/" + customerId;
		}
		else if (categoryL.startsWith("phone_emp")) {
			url = "/employeeprofile/" + customerId;
		}
	}
	else if (categoryL === "message") {
		url = "/message/" + messageId;
	}
	else if (categoryL === "phone_cc_logging") {
		url = "/contact/" + customerId;
	}
	console.log("url: ", url);
	return url;
};
